import {configureStore} from '@reduxjs/toolkit'
import userReducer from "../src/Components/UserSlice"

const appStore = configureStore({
    reducer: {
        user : userReducer
    },
})

export default appStore